import { FC } from 'react';
import { CardText } from 'react-bootstrap';
import { ProjectStatusType } from './ProjectStatusTypes.ts';
import styles from './ProjectStatus.module.scss';

/**
 * Props for the ProjectStatus component.
 */
interface ProjectStatusProps {
    status: ProjectStatusType;
}

const ProjectStatus: FC<ProjectStatusProps> = (props) => {
    const {
        status
    } = props;

    const isFinished: boolean = status.isFinished;

    return (
        <div
            className={styles.statusContainer}
        >
            <CardText
                className={`m-0 ${styles.statusBadge} ${isFinished ? styles.finished : styles.inProgress}`}
            >
                {status.status}
                {isFinished && (
                    <>
                        {status.completionMonth && (
                            <span>
                                {` ${status.completionMonth}`}
                            </span>
                        )}
                        {status.completionYear && (
                            <span>
                                {` ${status.completionYear}`}
                            </span>
                        )}
                    </>
                )}
            </CardText>
        </div>
    );
}

export default ProjectStatus;